const TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export const tokenManager = {
    // Store tokens
    setTokens(accessToken, refreshToken) {
        localStorage.setItem(TOKEN_KEY, accessToken);
        if (refreshToken) {
            localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
        }
    },

    // Get access token
    getAccessToken() {
        return localStorage.getItem(TOKEN_KEY);
    },

    // Get refresh token
    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    // Clear tokens
    clearTokens() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        // Also clear legacy token if exists
        localStorage.removeItem('token');
        localStorage.removeItem('user_sis');
    },

    // Check if token exists
    hasToken() {
        return !!this.getAccessToken();
    }
};




